import React, { memo } from 'react'
import { Handle, Position, type NodeProps } from 'reactflow'
import { nodeCardClass, nodeChipClass, nodeHandleClass, nodeIcon, nodeTextClass } from '../../nodeCatalog'

const TYPE = 'exitWorkflow'
const Icon = nodeIcon(TYPE)

const ExitWorkflowNode: React.FC<NodeProps> = ({ data, selected }) => {
  const reason = data.exit_workflow_config?.reason?.replace(/_/g, ' ') || 'exit'

  return (
    <div className={nodeCardClass(TYPE, selected)}>
      <Handle type="target" position={Position.Top} className={nodeHandleClass(TYPE)} />
      <div className="flex items-center gap-2">
        <div className={nodeChipClass(TYPE)}>
          <Icon className={`w-4 h-4 ${nodeTextClass(TYPE)}`} />
        </div>
        <div className="flex-1 min-w-0">
          <p className={`text-[10px] font-emphasis uppercase tracking-wider ${nodeTextClass(TYPE)}`}>Exit</p>
          <p className="text-sm font-medium text-foreground truncate">{data.label || 'Exit Workflow'}</p>
        </div>
      </div>
      <p className="mt-1 text-xs text-muted-foreground pl-10 capitalize">{reason}</p>
    </div>
  )
}

export default memo(ExitWorkflowNode)
